import * as React from 'react';
import { useTabs } from './Tabs';

export interface IPanelProps {
  label: string;
  className?: string;
  children?: React.ReactNode;
}

export const Panel: React.FC<IPanelProps> = (props) => {
  const { activeTab } = useTabs();
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (activeTab === props.label) {
      if (ref.current) {
        ref.current.scrollTop = 0;
      }
    }
  }, [activeTab, props.label]);

  return activeTab === props.label ? (
    <div
      ref={ref}
      className={
        props.className
          ? props.className
          : 'absolute top-0 left-0 right-0 bottom-0 mt-14 overflow-y-auto px-8 py-6'
      }
    >
      {props.children}
    </div>
  ) : null;
};
